// ============================================================
// components/snap-stash/SnapStashPage.tsx
//
// The /app/snap route (FR-W14): flow store provider + sheet.
// Deep-linkable; a ?session= query rehydrates an in-flight
// session via the snapshot endpoint (FR-W7).
// ============================================================
import { useEffect, useRef } from 'react';
import { useSearchParams } from 'react-router-dom';
import { SnapStashStoreProvider, useSnapStashStore } from '../../store/snap-stash/context';
import type { SnapStashDeps } from '../../store/snap-stash/createSnapStashStore';
import { SnapStashSheet } from './SnapStashSheet';

function SessionResume(): null {
  const [searchParams] = useSearchParams();
  const resumeFromSession = useSnapStashStore((state) => state.resumeFromSession);
  const attempted = useRef(false);

  useEffect(() => {
    const sessionId = searchParams.get('session');
    if (sessionId && !attempted.current) {
      attempted.current = true;
      void resumeFromSession(sessionId);
    }
  }, [searchParams, resumeFromSession]);
  return null;
}

interface SnapStashPageProps {
  /** Test seam — omit in production. */
  deps?: SnapStashDeps;
}

export function SnapStashPage({ deps }: SnapStashPageProps): React.JSX.Element {
  return (
    <SnapStashStoreProvider {...(deps ? { deps } : {})}>
      <SessionResume />
      <SnapStashSheet />
    </SnapStashStoreProvider>
  );
}
